import React, { useState } from 'react';
import ReactSelect from 'react-select';
import PropTypes from 'prop-types';
import { Controller, useForm } from 'react-hook-form';

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Switch,
  makeStyles,
  Divider,
  AccordionActions,
  Button
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SettingsIcon from '@material-ui/icons/Settings';
import SendIcon from '@material-ui/icons/Send';
import flespiDeviceService from '../../../../services/FlespiDeviceService';
import toast from 'react-hot-toast';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%'
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
    color: '#757575',
    fontWeight: '700'
  },
  accordionSummaryDiv: {
    display: 'flex',
    alignItems: 'center'
  },
  settingsDiv: {
    marginRight: '12px'
  },
  accordionDetails: {
    display: 'flex',
    flexDirection: 'column'
  }
}));

const accelerometerCalibrationOptions = [
  { value: 'disabled', label: 'Disabled', id: 0 },
  { value: 'once', label: 'Once', id: 1 },
  { value: 'continuous', label: 'Continuous', id: 2 }
];

const AccelerometerCalibration = ({ accelerometerCalibrationRecord }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const {
    control,
    formState: { errors },
    handleSubmit
  } = useForm({
    defaultValues: {
      accel_calibrate: accelerometerCalibrationRecord[0]?.current?.accel_calibrate,
      gravity_filter: accelerometerCalibrationRecord[0]?.current?.gravity_filter
    }
  });

  const handleAccelerometerCalibrationSetting = (data) => {
    setLoading(true);

    let accelerometerCalibrationPayload = {
      deviceId: accelerometerCalibrationRecord[0]?.device_id,
      settSelector: '"accelerometer_gravity"',
      properties: {
        accel_calibrate: data?.accel_calibrate,
        gravity_filter: data?.gravity_filter
      }
    };

    flespiDeviceService
      .updateFlespiDeviceSetting(accelerometerCalibrationPayload)
      .then((data) => {
        // eslint-disable-next-line no-console, no-undef
        console.log('data is:', data);
        toast.success('Successfully updated accelerometer calibration settings');
      })
      .catch((error) => {
        // eslint-disable-next-line no-console, no-undef
        console.log('error', error?.response?.data?.message);
        toast.error(error?.response?.data?.message || 'Unable to update accelerometer calibration settings');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // eslint-disable-next-line no-console, no-undef
  console.log('errors', errors);

  return (
    <div style={{ marginBottom: '1rem' }}>
      <form onSubmit={handleSubmit(handleAccelerometerCalibrationSetting)}>
        <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            className={classes.accordionSummary}
          >
            <div className={classes.accordionSummaryDiv}>
              <div className={classes.settingsDiv}>
                <SettingsIcon />
              </div>

              <div>
                <Typography className={classes.heading}>Accelerometer calibration and gravity filter</Typography>
              </div>
            </div>
          </AccordionSummary>

          <Divider />

          <AccordionDetails className={classes.accordionDetails}>
            <Typography style={{ color: '#9e9e9e', marginBottom: '10px' }}>
              Accelerometer calibration and gravity filter
            </Typography>

            <div>
              <Typography>Accelerometer auto calibration</Typography>
              <Controller
                control={control}
                name="accel_calibrate"
                render={({ field }) => (
                  <ReactSelect
                    className="basic-single"
                    classNamePrefix="select"
                    value={accelerometerCalibrationOptions.find((option) => option.id === field.value)}
                    isSearchable={true}
                    name="accel_calibrate"
                    options={accelerometerCalibrationOptions}
                    onChange={(selectedOption) => field.onChange(selectedOption ? selectedOption.id : null)}
                  />
                )}
              />
            </div>

            <div style={{ display: 'flex', marginTop: '1rem' }}>
              <Controller
                control={control}
                name="gravity_filter"
                render={({ field }) => (
                  <Switch
                    checked={field.value}
                    onChange={(e) => field.onChange(e.target.checked)}
                    color="primary"
                    name="gravity_filter"
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                  />
                )}
              />

              <Typography style={{ display: 'flex', alignItems: 'center' }}>Enable gravity filter</Typography>
            </div>
          </AccordionDetails>

          <AccordionActions style={{ cursor: 'pointer' }}>
            <Button
              size="small"
              color="primary"
              title="Changes will apply to the device"
              type="submit"
              disabled={loading}
            >
              <SendIcon />
            </Button>
          </AccordionActions>
        </Accordion>
      </form>
    </div>
  );
};

export default AccelerometerCalibration;

AccelerometerCalibration.propTypes = {
  accelerometerCalibrationRecord: PropTypes.array
};
